import Autocomplete from '@mui/material/Autocomplete';
import {styled} from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import React from 'react';

const StyledAutocomplete = styled(Autocomplete)(({theme}) => ({
  display: 'inline-flex',
  flexDirection: 'column',
  padding: theme.spacing(0),
  margin: theme.spacing(0.5),
  width: '32.6%',
  height: 'auto',
}));

const CustomAutoComplete = ({
  id,
  label,
  multiple,
  disabled,
  options,
  filterSelectedOptions,
  value,
  onChange,
  error,
  helperText,
}) => {
  return (
    <StyledAutocomplete
      id={id}
      multiple={multiple}
      disabled={disabled}
      options={options}
      getOptionLabel={(option) => option?.label}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      value={value}
      filterSelectedOptions={filterSelectedOptions}
      onChange={(e, newValue) => onChange(id, newValue)}
      renderInput={(params) => (
        <TextField {...params} error={error} helperText={helperText} label={label} placeholder={label} />
      )}
    />
  );
};

export default CustomAutoComplete;
